(ns basic-components.inputs.integer
  (:require
   [basic-components.inputs.footprint :refer [display-string editor viewer]]
   [clojure.string :as string]
   [frontend.utils :as fu]
   [reagent.core :as r]))

(defn render
  [dom-atom args]
  (let [{:keys [value class-name placeholder
                has-focus? cursor-at-end-on-focus? select-all-on-focus?
                on-focus! on-blur! on-change!
                on-key-down! disabled? base-multiplier auto-focus]}
        args
        raw-value (:temp-value @dom-atom)
        neg-state? (:negative? @dom-atom)
        cleared? (:cleared? @dom-atom)
        edit-value (or raw-value
                       (when neg-state? "-")
                       (when-not cleared? value))
        clear-state! (fn []
                       (swap! dom-atom dissoc
                         :temp-value
                         :negative?
                         :cleared?))]
    [:input
     (merge {:ref         (fn [e]
                            (when (and e
                                       (not= e (:input-dom-node @dom-atom)))
                              (swap! dom-atom assoc :input-dom-node e)))
             :placeholder (str placeholder)
             :type        "text"
             :class-name  (fu/cs "input-area" (when has-focus? "focus") class-name)
             :on-focus    (fn [e]
                            (swap! dom-atom assoc :focus? true)
                            (fu/timeout 50                  ;; must do this in timeout since focus may be called before mount
                                        (fn []
                                          (cond cursor-at-end-on-focus?
                                                (fu/put-cursor-at-end! dom-atom)
                                                :else       ;TODO - add select-all-on-focus?
                                                (.select (:input-dom-node @dom-atom)))))
                            (when on-focus!
                              (on-focus! e)))
             :on-blur     (fn [e]
                            (when on-blur!
                              (on-blur! e edit-value clear-state!)))
             :value       edit-value
             :on-key-down on-key-down!
             :on-change   (fn [e]
                            (let [input (-> e
                                            .-target
                                            .-value)
                                  js-format (string/replace input #"[^-0-9]" "")
                                  int-value (js/parseInt js-format)
                                  int-value (when-not (js/isNaN int-value) int-value)
                                  neg? (zero? (.indexOf input "-"))]
                              (swap! dom-atom assoc
                                :negative? (or neg? false)
                                :temp-value int-value
                                :cleared? (empty? input)) ;; this is used for clearing the value and not displaying the old-value when empty
                              (when on-change!
                                (on-change! e int-value))))
             :auto-focus  (boolean auto-focus)}
            (when disabled?
              {:disabled (boolean disabled?)}))]))

(defmethod editor :editor.type/integer
  [args]
  (let [dom-atom (or (:state-atom args) (r/atom nil))
        set-focusable! (:set-focusable-element! args)
        set-cancel-edit! (:set-cancel-edit! args)
        set-save! (:set-save! args)]                        ;; when do we reset the state ?
    ;; ref vs atom
    (r/create-class
     {:display-name           "Integer"
      :component-did-mount    (fn [args]
                                (let []
                                  ;; we use this to know where focus is changing - we can prevent blur if focus is changing to
                                  ;; events withing this editor if needed
                                  (when set-focusable!
                                    (set-focusable! (fn [_]
                                                      (when-let [dom-node (:input-dom-node @dom-atom)]
                                                        (.focus dom-node)))))
                                  (when set-cancel-edit!
                                    (set-cancel-edit! (fn [_]
                                                        (swap! dom-atom dissoc :temp-value)))) ;; save complete -> reset temp state
                                  (when set-save!
                                    (set-save! (fn [_]
                                                 (when-let [dom-node (:input-dom-node @dom-atom)]
                                                   (.blur dom-node)))))))
      :component-did-update   (fn [])
      :component-will-unmount (fn []
                                (swap! dom-atom dissoc :input-dom-node))
      :reagent-render         (fn [args]
                                (render dom-atom args))})))

(defmethod display-string :editor.type/integer
  [args]
  (str (:value args)))

(defmethod viewer :editor.type/integer
  [args]
  (r/create-class
   {:display-name   "Integer/viewer"
    :reagent-render (fn [args]
                      [:div.input-text-viewer
                       (display-string args)])}))
